module.exports = __webpack_public_path__ + "static/img/modify.12d0de9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/modify.jpg
// module id = vmX9
// module chunks = 104